<template>
    <div class="layer-content">
        <div class="tit-type2" style="line-height:20px;">걸음마 아이오감을 이용해주셔서 감사합니다.</div>
        <div class="tit-type2" style="line-height:20px;">보건복지부가 시행하는 안심등하원 체계에 맞추어 저희 아이오감도 보조를 맞추고 있습니다.</div>
        <div class="tit-type2" style="line-height:20px;">등하원 정보는 아동정보가 보육통합정보시스템과 일치 하도록 되어있으며, 이에 따라 3월 운영은 보육통합정보시스템의 오픈(연도전환에 따른 개시)일정과 맞추어야 함을 알려드립니다.</div>
        <div class="tit-type2" style="line-height:20px;">보육통합정보시스템의 재개시 일정(3월 2일 8시)에 맞추어, 
            <br>저희 아이오감도 <span class="pc02">3월 2일 10시부터 오픈</span>되오니 양해를 바랍니다.</div>
        <div class="tit-type2" style="line-height:20px;">감사합니다.</div>
    </div>
</template>

<script>
export default {
    name : 'indexNoticePopup',
}
</script>